// Copyright © 2021 Move Closer
export var AbstractTheme;
(function (AbstractTheme) {
    AbstractTheme["Default"] = "default";
})(AbstractTheme || (AbstractTheme = {}));
